export const twoFactorCodePrefix = 'AG - '
export const codeSendDefaultDelay = 30
export const oneSecondMilliseconds = 1000
export const mediaQueryMaxWidth = '980px'

const listify = shape => Object.keys(shape).map(key => shape[key])

export const loginModes = {
  createNewPassword: 'create-new-password',
  forgotPassword: 'forgot-password',
  forgotPasswordEmailSent: 'forgot-password-email-sent',
  normal: 'normal',
  renewExpiredPassword: 'renew-expired-password',
  tfaCode: 'tfa-code',
  audit: 'audit',
  newUserLinkExpired: 'new-user-link-expired',
  forgottenPasswordLinkExpired: 'forgotten-password-link-expired'
}

export const loginModesList = listify(loginModes)

export const errorMessages = {
  USER_PENALIZED: 'USER_PENALIZED',
  CODE_SENDING_FAILED: 'CODE_SENDING_FAILED',
  CODE_SENDING_BLOCKED: 'CODE_SENDING_BLOCKED'
}

export const errorMessagesList = listify(errorMessages)

export const language = 'en'
